import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import React from 'react';

type Props = {
  isReverse?: boolean;
  lead?: string;
  title: string;
  children: React.ReactNode;
  image: {
    url: string;
    height: number;
    width: number;
  };
  button?: { title: string; onClick: () => void };
};

const FeatureSection = ({
  isReverse,
  title,
  lead,
  children,
  button,
  image,
}: Props) => (
  <Flex
    className="boxed-container"
    as="section"
    align="center"
    justify="center"
    pb="10"
    dir={isReverse ? `rtl` : `ltr`}
    mt={[16, null, 0]}
    direction={[`column-reverse`, null, null, `row`]}
  >
    <Flex dir="ltr" flex={1} direction="column">
      {lead && (
        <Text
          textAlign="start"
          mb={1}
          fontSize={[`md`, null, `2xl`]}
          color="brand.400"
        >
          {lead}
        </Text>
      )}
      <Heading textAlign="start" mb="9" as="h2" size="2xl" pe={[4, null, 0]}>
        {title}
      </Heading>
      {children}
      {!!button && (
        <Button
          w="fit-content"
          mt={14}
          onClick={button.onClick}
          variant="solid-brand-cta"
        >
          {button.title}
        </Button>
      )}
    </Flex>
    <Flex
      justify="center"
      ps={[0, null, 10]}
      flex={1}
      maxW={[`full`, null, null, `inherit`]}
    >
      <Image
        src={image.url}
        height={image.height}
        width={image.width}
        alt={title}
      />
    </Flex>
  </Flex>
);

export default FeatureSection;
